"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCheckout = exports.CheckoutProvider = void 0;
var _shoppingContext = require("@ori/shopping-context");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
// This can be extended by specific types for your Online properties

const checkoutContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const CheckoutProvider = ({
  configuration,
  children
}) => {
  const {
    shoppingContext
  } = (0, _shoppingContext.useShoppingContext)();
  const value = (0, _react.useMemo)(() => ({
    ...configuration,
    isQofVisible: shoppingContext?.showQuickOrderUnit ?? configuration.isQofVisible,
    maxValue: shoppingContext?.shoppingBag.maxProductQuantity ?? configuration.maxValue,
    periodId: shoppingContext?.periodId ?? configuration.periodId,
    customerId: shoppingContext?.customerId ?? configuration.customerId
  }), [configuration, shoppingContext?.customerId, shoppingContext?.periodId, shoppingContext?.shoppingBag.maxProductQuantity, shoppingContext?.showQuickOrderUnit]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(checkoutContext.Provider, {
    value: value,
    children: children
  });
};
exports.CheckoutProvider = CheckoutProvider;
const useCheckout = () => {
  const ctx = (0, _react.useContext)(checkoutContext);
  if (!ctx) {
    throw new Error('useCheckout must be used within a CheckoutProvider');
  }
  return ctx;
};
exports.useCheckout = useCheckout;